import {combineReducers} from 'redux'
import {publishedObjectsDm} from "../published-objects/publishedObjectsReducer";

export const rootReducer = () => combineReducers({
    publishedObjectsDm: publishedObjectsDm
})
